/** Status logs tab: paging + persisted column UI (matches useConfiguredTable.sessionStorageKey). */

export const deviceStatusPageSize = 20;
export const deviceStatusPageSizeOptions = [20, 40, 100];
export const startDateLimit = 89;
export const commonHeaders = {
    // serialNumber: "S.No",
    ts: {header:"Timestamp",desc:""},
};

export const deviceStatusTableConfig = {
    // Survives tab refreshes until logout clears the same localStorage key in auth/token flows.
    storageType: "local",
    sessionStorageKey: "deviceStatus.visibleColumns",
    defaultVisibleColumns: ["createdAt", "ps", "actmp", "acmd", "actions"],
    lockedColumns: ["actions"],
    columnSequence: ["createdAt", "ps", "actmp", "acmd", "actions"],
    defaultSort: { key: "createdAt", order: "desc" },
    keyAliases: {
        // Prefer createdAt label while hydrating from payloads that still list `ts`.
        createdAt: ["createdAt", "ts"],
    },
    columns: {
        createdAt: { label: "Created At", sortable: true, filterable: true, filterType: "text", minWidth: 220 },
        ps: { label: "Power State", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        actmp: { label: "AC Temp", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        acmd: { label: "AC Mode", sortable: true, filterable: true, filterType: "text", minWidth: 150 },
        actions: {
            label: "Actions",
            sortable: false,
            filterable: false,
            minWidth: 110,
            align: "center",
            justifyContent: "center",
            // Sticky rail: row details action stays visible when grid scrolls horizontally.
            headerCellSx: { position: "sticky", right: 0, zIndex: 3 },
            cellSx: { position: "sticky", right: 0, zIndex: 2, backgroundColor: "background.paper" }
        },
    },
};